module.exports = __webpack_public_path__ + "static/media/giftLogo_certification.29ebb64d.png";